/**
 * Last-resort way back to the portal when the embed bridge has no channel to
 * ask over: a real top-level navigation to the portal origin.
 *
 * Only ever taken when this window IS the top window — the therapist opened
 * the web build directly (standalone dev, a bookmarked embed URL). Inside the
 * portal that can never work and must not be attempted: the portal mounts us
 * in a sandboxed iframe without `allow-top-navigation`, so the browser would
 * refuse, and even if it didn't, a page load would drop the portal's in-memory
 * vault keys and land the therapist on the password prompt. In the iframe the
 * bridge's `requestPortalNavigation` is the only exit.
 *
 * Returns whether a navigation was started.
 */
export function leaveForPortal(): boolean {
  if (window.top !== window) return false

  const origin = (import.meta.env.VITE_PORTAL_EMBED_ORIGIN as string | undefined) ?? ''
  if (!origin) return false

  window.location.assign(origin)
  return true
}
